var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-form',{ref:"courseEditForm",staticClass:"w-full",attrs:{"fields-in-row":3,"form-data":_vm.courseForm,"edit-record":_vm.golfCourse},on:{"submitted":_vm.edit}})}
var staticRenderFns = []

export { render, staticRenderFns }